var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_warning_hi_light_theme") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01b-VWC-Error-states-Unable-to-fetch-detail-view",
    transform: "translate(-592.000000, -364.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(20.000000, 300.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning_hi",
    transform: "translate(572.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.215,70.13 C88.395,77.53 84.975,84 76.615,84 L19.385,84 C11.025,84 7.6,77.53 11.785,70.13 L40.4,17.525 C44.565,10.35 51.4,9.97 55.605,17.525 L84.215,70.13 Z",
    id: "37b7819c_16c7_4644_b4a8_2287306fbebd",
    fill: "#EBEBEB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.615,83 L19.385,83 C13.675,83 10.27,80 10.015,75.71 C9.765,80.5 13.24,84 19.385,84 L76.615,84 C82.76,84 86.235,80.5 85.985,75.71 C85.73,80 82.325,83 76.615,83 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,32 C46,30.8954305 46.8954305,30 48,30 C49.1045695,30 50,30.8954305 50,32 L50,60.25 C50,61.3545695 49.1045695,62.25 48,62.25 C46.8954305,62.25 46,61.3545695 46,60.25 L46,32 Z",
    id: "74c49690_151a_4fc8_9c60_5a7a49244759",
    fill: "#E60000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e3e0c83d_04f8_47a6_866c_cf9ed5ce1207",
    fill: "#E60000",
    fillRule: "nonzero",
    cx: 48,
    cy: 69.945,
    r: 3
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.c64eeb2d515367982ef34c499b5dbdd6.svg";
export { ForwardRef as ReactComponent };